import { useState } from "react";
import { Link } from "react-router-dom";
import { FaTimes, FaBars } from "react-icons/fa";
import logo from "../assets/emisaathi-logo.png";
import "./container.css";
import "./Navbar.css";

const NAV_LINKS = [
  { label: "Home", href: "/" },
  { label: "How It Works", href: "/how-it-works" },
  { label: "About Us", href: "/about" },
];

const REPAY_NOW_URL = `${import.meta.env.VITE_WEBSITE_LINK}/repay-now`;

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div>
      <nav className="w-full fixed top-0 left-0 z-50" style={{ background: "#032799" }}>
        <div className="navbar-inner container-8xl">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img
              className="navbar-logo"
              src={logo}
              alt={`${import.meta.env.VITE_COMPANY_NAME}`}
            />
          </Link>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center gap-4">
            {NAV_LINKS.map((item) => {
              const isActive = item.label === "Home";
              return (
                <Link
                  key={item.label}
                  to={item.href}
                  className="navbar-link font-['Inter'] font-[500] text-white transition-colors"
                  style={{
                    borderRadius: "6px",
                    background: isActive ? "#F94C09" : "transparent",
                  }}
                >
                  {item.label}
                </Link>
              );
            })}
          </div>

          {/* Repay Now + Contact Us CTA */}
          <div className="hidden md:flex items-center gap-3">
            <a
              href={REPAY_NOW_URL}
              target="_blank"
              rel="noreferrer"
              className="navbar-repay-btn inline-flex items-center font-['Inter'] font-[500] text-white transition-transform hover:scale-105"
              style={{ borderRadius: "96px", border: "1.5px solid #FFF" }}
            >
              Repay Now
            </a>
            <Link
              to="/contact"
              className="navbar-contact-btn inline-flex items-center font-['Inter'] font-[500] transition-transform hover:scale-105"
              style={{ borderRadius: "96px", background: "#FFF", color: "#032799" }}
            >
              Contact Us
            </Link>
          </div>

          {/* Mobile Hamburger */}
          <button
            className="md:hidden text-white text-2xl"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            {menuOpen ? <FaTimes /> : <FaBars />}
          </button>
        </div>

        {/* Mobile Menu */}
        {menuOpen && (
          <div className="md:hidden flex flex-col items-center gap-3 pb-6 px-6" style={{ background: "#032799" }}>
            {NAV_LINKS.map((item) => {
              const isActive = item.label === "Home";
              return (
                <Link
                  key={item.label}
                  to={item.href}
                  onClick={() => setMenuOpen(false)}
                  className="w-full text-center font-['Inter'] font-[500] text-[16px] text-white px-5 py-3 transition-colors"
                  style={{
                    borderRadius: "6px",
                    background: isActive ? "#F94C09" : "transparent",
                  }}
                >
                  {item.label}
                </Link>
              );
            })}

            <a
              href={REPAY_NOW_URL}
              target="_blank"
              rel="noreferrer"
              className="w-full text-center font-['Inter'] font-[500] text-[16px] text-white px-5 py-3"
              style={{ borderRadius: "96px", border: "1.5px solid #FFF" }}
            >
              Repay Now
            </a>

            <Link
              to="/contact"
              onClick={() => setMenuOpen(false)}
              className="w-full text-center font-['Inter'] font-[500] text-[16px] px-5 py-3"
              style={{ borderRadius: "96px", background: "#FFF", color: "#032799" }}
            >
              Contact Us
            </Link>
          </div>
        )}
      </nav>
    </div>
  );
};

export default Navbar;
